import type { ReactNode } from 'react'

import { SettingsRow } from '@/components/settings/settings-row'

export type SettingsImageUploadRowProps = {
  label: string
  description?: string
  children: ReactNode
  showDivider?: boolean
}

/** Settings-class image row — label left, upload control right (matches text field rows). */
export function SettingsImageUploadRow({
  label,
  description,
  children,
  showDivider = true,
}: SettingsImageUploadRowProps) {
  return (
    <SettingsRow label={label} description={description} showDivider={showDivider}>
      {children}
    </SettingsRow>
  )
}
